import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { SharedModule } from "../../../shared/shared.module";
// import { AvatarModule } from 'ngx-avatar';
import { MatToolbarModule } from "@angular/material/toolbar";
import { LanguageSelectorModule } from '../language-selector/language-selector.module';


@NgModule({
    declarations: [
        ToolbarComponent
    ],
    imports: [
        RouterModule,
        SharedModule,
        MatToolbarModule,
        LanguageSelectorModule,

        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule
    ],
    exports: [
        ToolbarComponent
    ]
})
export class ToolbarModule {
}
